import React, { useEffect, useState } from 'react';
import '../../scss/app.scss';
import "react-toggle/style.css"
import { BillsVService, BillingAccountsVService, PaymentTransactionTypeEnum, TokensVService, TransactionsVService, AllowedAction, PaymentTypeEnum, PaymentChannel } from '../../services/V2/gozer';
import { RecentBill } from './Cards/RecentBill';
import { RecentUsage } from './Cards/RecentUsage';
import { BillingInformation } from './Cards/BillingInformation';
import { EnrollmentSettings } from './Cards/EnrollmentSettings';
import { CircularProgress, Grid } from '@mui/material';
import { withToast } from '../Shared/Toast';
import { handleError } from '../Shared/Functions';
import { PaymentProcessorEnum } from '../../services/V3/gozer';

const AccountDetail = ({ account, successToast, errorToast }) => {
    let [loading, setLoading] = useState<boolean>(false);
    let [recurring, setRecurring] = useState<any>(undefined)
    let [lastPayment, setLastPayment] = useState<any>(null);
    let [enrollment, setEnrollment] = useState<any>(null);
    let [meterConfigs, setMeterConfigs] = useState<any>(null);
    let [bill, setBill] = useState<any>(null);
    let [bills, setBills] = useState<any[]>([]);
    const nonElectronicPayments = [PaymentTypeEnum.CASH, PaymentTypeEnum.MONEY_ORDER, PaymentTypeEnum.OTHER, PaymentTypeEnum.CHECK]
    const nonElectronicChannels = [PaymentChannel.LOCK_BOX, PaymentChannel.THIRD_PARTY_ACH, PaymentChannel.THIRD_PARTY_CC, PaymentChannel.U_RECEIVABLES, PaymentChannel.U_SCAN]

    useEffect(() => {
        if(!account || !loading)return; 
        setMeterConfigs(account.usageInfo)
        Promise.all(
            [
                TransactionsVService.transactionsVGetAll(account.id ?? "", {
                    pageNumber: 1,
                    numberPerPage: 15,
                    filters: [{
                            property: "BillingAccountId",
                            value: account.id
                        },
                        {
                            property: "Error",
                            value: null
                        }
                    ],
                    orderBy: "CreatedAt",
                    orderByDesc: true,
                }),
                TokensVService.tokensVGetAll(account.id),
                BillingAccountsVService.billingAccountsVGetEnrollment(account.id),
                BillsVService.billsVGetPastTwoYears(account.id)
            ]
        ).then(([pmtHistory, tokens, enroll, apiBills]) => {
            setRecurring(tokens.find(x => x.isRecurring));
            setEnrollment(enroll);
            if (pmtHistory?.items && pmtHistory.items.length && pmtHistory.items.length > 0) {
                let orderedPayments: any = pmtHistory.items;
                if (orderedPayments?.length && orderedPayments?.length > 0) {
                    let count = 0;
                    let recentPayment: any | null = null;
                    while (recentPayment === null && count < orderedPayments.length) {
                        if (orderedPayments[count].paymentTransactionType === PaymentTransactionTypeEnum.CHARGE &&
                            (orderedPayments[count].allowedAction !== AllowedAction.NONE ||
                                nonElectronicPayments.includes(orderedPayments[count].paymentType) ||
                                nonElectronicChannels.includes(orderedPayments[count].channel) ||
                                orderedPayments[count].paymentProcessor === PaymentProcessorEnum.OTHER)) {
                            recentPayment = {
                                amount: orderedPayments[count].amount ?? 0,
                                date: new Date(orderedPayments[count].createdAt ?? 0)
                            };
                        }
                        count++
                    }
                    setLastPayment(recentPayment);
                }

            } else {
                setLastPayment(null)
            }

            if (apiBills) {
                setBill(apiBills.find(x => x.billStoredObjectId !== null));
                setBills(apiBills)
            }

            setLoading(false);
        }).catch(err => err.message !== "Not Found" && errorToast(handleError(err)))
    }, [loading])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => { 
        if(account === null) return;  
        setLoading (true) 
    }, [account]) 

    return (loading ?
        <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div> :
            <Grid container className='account-detail-container'>
                <Grid item className='bill-grid'>
                    <span className='bill-info'>
                        <RecentBill
                            account={account}
                            lastPayment={lastPayment}
                            bill={bill}
                            recurring={recurring}
                            fail={errorToast} />
                    </span>
                </Grid>
                <Grid item className='settings-grid'>
                    <Grid item className='enrollment-grid' lg={6}>
                        <EnrollmentSettings
                            account={account}
                            recurring={recurring}
                            enrollment={enrollment}
                            setEnrollment={setEnrollment}
                            success={successToast} />
                    </Grid>
                    <Grid item className='billing-info-grid' lg={6}>
                        <BillingInformation account={account} />
                    </Grid>
                </Grid>
                <Grid item className='usage-grid'>
                    <RecentUsage
                        bills={bills.slice(0, 12)}
                        meterConfigs={meterConfigs} />
                </Grid>
            </Grid>
    )

}
export default withToast(AccountDetail);
